import { render, staticRenderFns } from "./BarChartFixed.vue?vue&type=template&id=64a423ab&scoped=true&"
import script from "./BarChartFixed.vue?vue&type=script&lang=js&"
export * from "./BarChartFixed.vue?vue&type=script&lang=js&"
import style0 from "./BarChartFixed.vue?vue&type=style&index=0&id=64a423ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a423ab",
  null
  
)

export default component.exports